import {Button, Chip, Typography} from "@material-tailwind/react";
import React, {memo, useContext, useState} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {TableHead} from "../system/thead";
import TableTdContent from "../system/tableTdContent";
import {PaginateContext} from "../../context/paginate";

const getServiceStatusDisplay = (status, completed_full_payment) => {
  switch (status) {
    case 'new':
      return { label: Dict('new'), color: 'indigo' };
    case 'rejected':
      return { label: Dict('rejected'), color: 'red' };
    case 'payment':
      return {
        label: completed_full_payment === false ? Dict('down_payment') : Dict('payment'),
        color: completed_full_payment === false ? 'yellow' : 'green',
      };
    case 'finish':
      return { label: Dict('finish'), color: 'green' };
    default:
      return { label: Dict('new'), color: 'indigo' };
  }
};

const formatNullable = (value) => value === null || value === undefined || value === "" ? "-" : value;

const formatFullName = (...parts) => {
  const name = parts.filter(Boolean).join(" ").trim();
  return name || "-";
};

const TABLE_HEAD = ["#", "مباشر", "گرایش", "روز انجام خدمت", "وضعیت", "مبلغ", "موضوع", "چالش", "گزارش پیشرفت", "عملیات"];

function PersonServiceGridComponent({services, onOpenCheck, onOpenReport}) {
  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "مباشر": "agent_name",
    "گرایش": "field_title",
    "روز انجام خدمت": "day",
    "وضعیت": "status",
    "مبلغ": "price",
    "موضوع": "topic",
    "چالش": "challenge",
    "گزارش پیشرفت": "",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "مباشر": true,
    "گرایش": true,
    "روز انجام خدمت": true,
    "وضعیت": true,
    "مبلغ": true,
    "موضوع": true,
    "چالش": true,
    "گزارش پیشرفت": false,
    "عملیات": false,
  }

  return (
    <div className="w-full border border-blue-gray-100 rounded-xl overflow-hidden [&_button]:min-w-0 [&_button]:px-1 [&_button]:py-2">
      <table className="w-full table-fixed text-left">
        <colgroup>
          <col className="w-[4%]"/>
          <col className="w-[12%]"/>
          <col className="w-[12%]"/>
          <col className="w-[9%]"/>
          <col className="w-[9%]"/>
          <col className="w-[9%]"/>
          <col className="w-[13%]"/>
          <col className="w-[13%]"/>
          <col className="w-[9%]"/>
          <col className="w-[10%]"/>
        </colgroup>
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter divide-y divide-blue-gray-100">
        {services.map(
          ({
             id,
             title,
             agent_name,
             agent_family,
             field_title,
             branch_title,
             day,
             status,
             price,
             topic,
             challenge,
             completed_full_payment
           }, index) => {
            const isLast = index === services.length - 1;
            const classes = isLast ? "p-4" : "p-4";

            return (
              <tr key={id}>
                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={`${classes}`}>
                  <TableTdContent content={formatFullName(agent_name, agent_family)}/>
                </td>

                <td className={`${classes}`}>
                  <TableTdContent content={formatFullName(field_title, branch_title)}/>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-2">
                    <Typography color="blue-gray" className="textRight break-words">
                      {formatNullable(persianNumberFormat(day, true))}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-2">
                    {(() => {
                      const { label, color } = getServiceStatusDisplay(status, completed_full_payment);
                      return (
                        <Chip
                          variant="ghost"
                          color={color}
                          size="sm"
                          value={label}
                        />
                      );
                    })()}
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-2">
                    <Typography color="blue-gray" className="textRight break-words">
                      {formatNullable(persianNumberFormat(price, true))}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <TableTdContent content={formatNullable(topic)}/>
                </td>

                <td className={classes}>
                  <TableTdContent content={formatNullable(challenge)}/>
                </td>

                <td className={classes}>
                  <Button variant="text" onClick={() => {
                    onOpenReport(services[index]);
                  }}
                  >
                    گزارش پیشرفت
                  </Button>
                </td>

                <td className={classes}>
                  {status === "waiting" &&
                    <Button variant="outlined" onClick={() => {
                      onOpenCheck(services[index]);
                    }}
                    >
                      مشاهده/پرداخت
                    </Button>
                  }
                  {status !== "finish" && status !== "waiting" &&
                    <Button variant="outlined" onClick={() => {
                      onOpenCheck(services[index]);
                    }}
                    >
                      مشاهده/تکمیل مدارک
                    </Button>
                  }
                  {status === "finish" &&
                    <Button variant="outlined" onClick={() => {
                      onOpenCheck(services[index]);
                    }}
                    >
                      مشاهده
                    </Button>
                  }
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  )
    ;
}

export const PersonServiceGrid = memo(PersonServiceGridComponent);
